import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TLM_MASTER } from "../apiRoutes";

const mutateAddTlmMaster = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(TLM_MASTER, data);
};

const useAddTlmMasterMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddTlmMaster,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch TLM master queries
      queryClient.invalidateQueries({
        queryKey: ["tlmMaster"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddTlmMasterMutation;
